import { type JSX, useId } from 'react'
import { cn } from '#src/cn.ts'

export function IconHexagonX({
  className,
}: {
  className?: string
}): JSX.Element {
  const id = useId()
  return (
    <svg
      className={cn('size-4 shrink-0', className)}
      width="16"
      height="16"
      viewBox="-1 -1 16 16"
      fill="none"
      stroke="none"
    >
      <path
        d="M2.95778 3.02069L5.70777 1.36023C6.50244 0.88041 7.49756 0.88041 8.29223 1.36024L11.0422 3.02074C11.7918 3.47336 12.25 4.2852 12.25 5.16086V8.84803C12.25 9.7251 11.7904 10.5381 11.0388 10.9902L8.29114 12.6433C7.49693 13.1211 6.50355 13.1203 5.71011 12.6412L2.95775 10.9792C2.20815 10.5266 1.75 9.7148 1.75 8.83911V5.16082C1.75 4.28516 2.20816 3.47332 2.95778 3.02069Z"
        stroke="#8A8F98"
        strokeWidth="1.5"
        strokeLinejoin="bevel"
        strokeDasharray="3.14 0"
        strokeDashoffset="1"
        fill="none"
      ></path>
      <g mask={`url(#${id}-hole-100)`}>
        <circle
          r="4"
          cx="7"
          cy="7"
          stroke="#8A8F98"
          fill="none"
          strokeWidth="8"
          strokeDasharray="calc(25.12) 25.12"
          transform="rotate(-90) translate(-14, 0)"
        ></circle>
      </g>
      <mask id={`${id}-hole-100`} maskUnits="userSpaceOnUse">
        <path
          transform="translate(-7.5, -7.5) scale(1.8)"
          d="M8.3779 4.74233C8.14438 4.60607 7.85562 4.60607 7.6221 4.74233L5.37209 6.05513C5.14168 6.18957 5 6.4363 5 6.70311V9.34216C5 9.60897 5.14168 9.85573 5.37209 9.99016L7.6221 11.303C7.85562 11.4392 8.14438 11.4392 8.3779 11.303L10.6279 9.99016C10.8583 9.85573 11 9.60897 11 9.34216V6.70311C11 6.4363 10.8583 6.18957 10.6279 6.05513L8.3779 4.74233Z"
          fill="white"
        ></path>
        <path
          stroke="none"
          fill="black"
          d="M3.73657 3.73657C4.05199 3.42114 4.56339 3.42114 4.87881 3.73657L5.93941 4.79716L7 5.85775L9.12117 3.73657C9.4366 3.42114 9.94801 3.42114 10.2634 3.73657C10.5789 4.05199 10.5789 4.56339 10.2634 4.87881L8.14225 7L10.2634 9.12118C10.5789 9.4366 10.5789 9.94801 10.2634 10.2634C9.94801 10.5789 9.4366 10.5789 9.12117 10.2634L7 8.14225L4.87881 10.2634C4.56339 10.5789 4.05199 10.5789 3.73657 10.2634C3.42114 9.94801 3.42114 9.4366 3.73657 9.12118L4.79716 8.06059L5.85775 7L3.73657 4.87881C3.42114 4.56339 3.42114 4.05199 3.73657 3.73657Z"
        ></path>
      </mask>
    </svg>
  )
}
